import type { User as ReactNativeFirebaseUser } from '@react-native-firebase/auth';
import type { User } from 'firebase/auth';
import { privateExchanges, resetUrqlClient } from '@/client/urqlClient';
import useAuthStore from '@/stores/useAuthStore';
import { resetChatSession } from '@/stores/useChatStore';
import useRootStore from '@/stores/useRootStore';
export default function useHandleAuthStateChange() {
  const handleAuthStateChange = (
    user: ReactNativeFirebaseUser | User | null,
  ) => {
    const currentAuthState = useAuthStore.getState();
    if (!user || (currentAuthState.uid && currentAuthState.uid !== user.uid)) {
      resetChatSession();
      useRootStore.setState({
        organizationId: null,
        teamId: null,
        activeContextPathname: null,
        activeTab: 'event',
        isDrawerOpen: false,
      });
    }

    if (user) {
      if (
        currentAuthState.status !== 'in' ||
        currentAuthState.uid !== user.uid
      ) {
        resetUrqlClient({
          key: 'private',
          exchanges: privateExchanges,
        });
      }
      useAuthStore.setState({
        status: 'in',
        uid: user.uid,
      });
    } else if (user === null) {
      if (currentAuthState.status === 'in' || currentAuthState.uid) {
        resetUrqlClient({
          key: 'private',
          exchanges: privateExchanges,
        });
      }

      useAuthStore.setState({
        status: 'out',
        uid: null,
      });
    }
  };
  return handleAuthStateChange;
}
